export enum AlignmentType {
    center = "center",
    left = "left",
    right = "right",
    top = "top",
    bottom = "bottom",
    mousePoint = 'mousepoint'
}